<template>
  <v-data-table
    :headers="header"
    :items="gruposeparacaofiliais"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    item-key="id"
    class="elevation-2 table-full-screen mx-1"
    :height="ALTURA_TABELA"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <div class="d-flex ml-n2">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-weight-medium">Grupo de Separação Filial</p>
        </div>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          single-line
          hide-details
          clearable
          class="pr-5"
          style="max-width: 450px"
        ></v-text-field>

        <SysDialog
          v-model="dialog"
          :titulo="title"
          @click:primary="salvar"
          @click:hidden-dialog="$v.$reset()"
        >
          <template #ativador>
            <v-btn color="primary" dark small @click="dialog = true">
              <v-icon left>mdi-plus</v-icon>
              <span>Novo</span>
            </v-btn>
          </template>

          <v-autocomplete
            v-model="form.id_grupo_sep"
            :items="select.options.gruposeparacao"
            label="Escolha o Grupo de Separação*"
            clearable
            outlined
            item-text="descricao"
            item-value="id"
            :error-messages="errorGrupoSeparacao"
            @input="$v.form.id_grupo_sep.$touch()"
            @blur="$v.form.id_grupo_sep.$touch()"
          />

          <v-autocomplete
            v-model="form.filial"
            :items="[...select.options.hubs, ...select.options.filial]"
            label="Escolha a Filial*"
            clearable
            outlined
            chips
            item-text="descricao_filial"
            item-value="filial"
            multiple
            :error-messages="errorFilial"
            @input="$v.form.filial.$touch()"
            @blur="$v.form.filial.$touch()"
          />
        </SysDialog>
      </v-toolbar>
    </template>

    <template v-slot:item.filial="{item}">
      <v-chip v-for="(item, key) in item.filial" :key="key" class="mr-1">
        {{item}}
      </v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <v-btn
        icon
        title="Editar Grupo Separacao"
        class="mr-2"
        @click="editar(item)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn icon title="Remover Grupo Separacao" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">More info about {{ item.name }}</td>
    </template>
  </v-data-table>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DrpAPI from "../../../api/drp";
import Api from "../../../api/cfg";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {iniciarRequisicao, logout} from "@/helpers";
import api from "@/api/api";
import {STATUS_HTTP} from "@/api/statusHTTP";

export default {
  components: {SysDialog},
  props: ["atualizar"],
  data() {
    return {
      expanded: [],
      singleExpand: false,
      header: [
        { text: "Grupo de Separação", value: "descricao" },
        { text: "Filial", value: "filial" },
        {
          text: "Dt. Cadastro",
          value: "data_cadastro",
          width: "120px",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "120px",
          align: "right",
        },
      ],
      select: {
        options: {
          filial: [],
          hubs: [],
          grupoSeparacao: [],
        },
      },
      gruposeparacaofiliais: [],
      soGrupoSeparacao: [],
      search: "",
      dialog: false,
      title: "Novo Grupo de Separação Filial",
      form: {
        id_grupo_sep: "",
        filial: [],
      },
    };
  },
  validations: {
    form: {
      id_grupo_sep: { required },
      filial: { required },
    },
  },
  computed: {
    errorGrupoSeparacao() {
      const errors = [];
      if (!this.$v.form.id_grupo_sep.$dirty) return errors;
      !this.$v.form.id_grupo_sep.required &&
        errors.push("O grupo de separação é obrigatório.");
      return errors;
    },
    errorFilial() {
      const errors = [];
      if (!this.$v.form.filial.$dirty) return errors;
      !this.$v.form.filial.required && errors.push("A filial é obrigatório.");
      return errors;
    },
    ALTURA_TABELA() {
      const altura_config = '255px';
      const altura_parametrizacao = '230px';

      return this.$route.meta.layout == 'parametrizacao' ? `calc(100vh - ${altura_parametrizacao})` : `calc(100vh - ${altura_config})`;
    }
  },
  created() {
    this.selects();
    this.buscarListaDeHubs();
    this.listar();
  },
  methods: {
    listar() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.getGrupoSeparacaoFilial(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.gruposeparacaofiliais = response.data.gruposeparacaofilial;
              this.gruposeparacaofiliais.forEach((e, k) => {
                this.gruposeparacaofiliais[k]["id"] = k;
              });
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = item.id_grupo_sep;

        this.$store.dispatch("loading/addRequisicao",
          DrpAPI.deleteGrupoSeparacaoFilial(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              if (response.status == 200) {
                this.listar();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    editar(prop) {
      this.dialog = true;
      this.form.id_grupo_sep = prop.id_grupo_sep;
      this.form.filial = prop.filial;
      this.title = "Editar Grupo de Separacao";
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.form;

        this.$store.dispatch("loading/addRequisicao",
          DrpAPI.createGrupoSeparacaoFilial(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.listar();
              this.close();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    close() {
      this.title = "Novo Grupo de Separacao";
      this.form = {
        id_grupo_sep: "",
        filial: [],
      };
      this.dialog = false;
      this.$v.$reset();
    },
    selects() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };

      this.$store.dispatch("loading/addRequisicao",
        Api.getGrupoFilial(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.select.options.filial = response.data.grupoFilial.map(item => ({
                ...item,
                descricao_filial: `Filial ${item.filial}`
              }));
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.getGrupoSeparacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.soGrupoSeparacao = response.data.gruposeparacao;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    buscarListaDeHubs() {
      api.get('drp/hubs')
        .then(response => {
          this.select.options.hubs = response.data.hubs.map(item => ({
            ...item,
            descricao_filial: item.descricao
          }));
        })
        .catch(logout)
    }
  },
  watch: {
    dialog() {
      let opt = [...this.soGrupoSeparacao];
      if (this.form.filial.length > 0) {
        opt = opt.filter((o) => {
          return this.form.id_grupo_sep == o.id;
        });
      } else {
        this.gruposeparacaofiliais.forEach((g) => {
          opt = opt.filter((o) => {
            return g.descricao != o.descricao;
          });
        });
      }
      this.select.options.gruposeparacao = opt;
    },
    atualizar() {
      if (this.atualizar == 3) {
        this.selects();
        this.listar();
      }
    },
  },
};
</script>
